module.exports = __webpack_public_path__ + "img/p-right.120dd99d.svg";